import { Action } from '@ngrx/store'
import { Event } from '../models'

export const INIT_EVENTS_ON_VIDEO = '[Event] Init Events On Video'
export const LOAD_EVENTS_ON_VIDEO = '[Event] Load Events On Video'
export const ADD_EVENT_ON_VIDEO = '[Event] Add Event On Video'
export const UPDATE_EVENT_ON_VIDEO = '[Event] Update Event On Video'
export const REMOVE_EVENT_ON_VIDEO = '[Event] Remove Event On Video'

export const INIT_EVENTS_ON_STATIC_CONTENT = '[Event] Init Events On Static Content'
export const LOAD_EVENTS_ON_STATIC_CONTENT  = '[Event] Load Events On Static Content'
export const ADD_EVENT_ON_STATIC_CONTENT = '[Event] Add Event On Static Content'
export const UPDATE_EVENT_ON_STATIC_CONTENT = '[Event] Update Event On Static Content'
export const REMOVE_EVENT_ON_STATIC_CONTENT  = '[Event] Remove Event On Static Content'

export class InitVideoEvents implements Action {
  readonly type = INIT_EVENTS_ON_VIDEO

  constructor() { }
}

export class LoadVideoEvents implements Action {
  readonly type = LOAD_EVENTS_ON_VIDEO

  constructor(public videoId: number, public events: Event[]) { }
}

export class AddVideoEvent implements Action {
  readonly type = ADD_EVENT_ON_VIDEO

  constructor(public event: Event, public enabledChatgpt?:boolean) { }
}

export class UpdateVideoEvent implements Action {
  readonly type = UPDATE_EVENT_ON_VIDEO

  constructor(public event: Event) { }
}

export class RemoveVideoEvent implements Action {
  readonly type = REMOVE_EVENT_ON_VIDEO

  constructor(public eventId: number) { }
}

export type VideoAll
  = InitVideoEvents
  | LoadVideoEvents
  | UpdateVideoEvent
  | AddVideoEvent
  | RemoveVideoEvent

export class InitStaticContentEvents implements Action {
  readonly type = INIT_EVENTS_ON_STATIC_CONTENT

  constructor() { }
}

export class LoadStaticContentEvents implements Action {
  readonly type = LOAD_EVENTS_ON_STATIC_CONTENT

  constructor(public staticContentId: number, public events: Event[]) { }
}

export class AddStaticContentEvent implements Action {
  readonly type = ADD_EVENT_ON_STATIC_CONTENT

  constructor(public event: Event,public enabledChatgpt?:boolean) { }
}

export class UpdateStaticContentEvent implements Action {
  readonly type = UPDATE_EVENT_ON_STATIC_CONTENT
  
  constructor(public event: Event) { }
}

export class RemoveStaticContentEvent implements Action {
  readonly type = REMOVE_EVENT_ON_STATIC_CONTENT

  constructor(public eventId: number) { }
}

export type StaticContentAll
  = InitStaticContentEvents
  | LoadStaticContentEvents
  | UpdateStaticContentEvent
  | AddStaticContentEvent
  | RemoveStaticContentEvent

export type All
  = VideoAll
  | StaticContentAll



// WEBPACK FOOTER //
// ./src/actions/event.ts